export default __webpack_public_path__ + "static/media/Javascript.dd493364.png";